import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Crew from "@/pages/Crew";
import Approvals from "@/pages/Approvals";
import Marketer from "@/pages/Marketer";
import Sales from "@/pages/Sales";
import Accountant from "@/pages/Accountant";
import AdminWaitlist from "@/pages/AdminWaitlist";
import ResetPassword from "@/pages/ResetPassword";
import AppLayout from "@/components/AppLayout";
import AuthCallback from "@/components/AuthCallback";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen aurora flex items-center justify-center">
        <div className="glass px-6 py-4 rounded-2xl font-display">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace state={{ from: location }} />;
  if (!user.onboarded && location.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  return children;
}

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/reset" element={<ResetPassword />} />
      <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
      <Route path="/dashboard" element={<Protected><AppLayout><Dashboard /></AppLayout></Protected>} />
      <Route path="/crew" element={<Protected><AppLayout><Crew /></AppLayout></Protected>} />
      <Route path="/approvals" element={<Protected><AppLayout><Approvals /></AppLayout></Protected>} />
      <Route path="/marketer" element={<Protected><AppLayout><Marketer /></AppLayout></Protected>} />
      <Route path="/sales" element={<Protected><AppLayout><Sales /></AppLayout></Protected>} />
      <Route path="/accountant" element={<Protected><AppLayout><Accountant /></AppLayout></Protected>} />
      <Route path="/admin/waitlist" element={<Protected><AppLayout><AdminWaitlist /></AppLayout></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Router />
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </BrowserRouter>
  );
}
